import { render, staticRenderFns } from "./ButtonsSmallerRounded.vue?vue&type=template&id=64a0b3be&"
import script from "./ButtonsSmallerRounded.vue?vue&type=script&lang=js&"
export * from "./ButtonsSmallerRounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports